import { Card, Skeleton } from '@skytech/ui'
import { Button } from '@skytech/ui/Button'

import { Translation } from '@/app/translations/Translation'

const SettingsSkeleton = () => {
  const isMobile = () => window.innerWidth <= 600

  return (
    <>
      <button className="edit-name-and-desc">
        <h2>
          <Skeleton height="47px" width={isMobile() ? '250px' : '350px'} />
        </h2>

        <h3>
          <Skeleton height="27px" width={isMobile() ? '250px' : '350px'} />
        </h3>
      </button>

      <span className="ecom-policy-bullet-points">
        <Skeleton
          height="36px"
          width={isMobile() ? '250px' : '500px'}
          style={{ display: 'block', margin: isMobile() ? 0 : '1rem' }}
        />
      </span>

      <div className="input-cards">
        <Card className="amount-limits">
          <h3>
            <Translation id="Amount limits" />
          </h3>
          <Skeleton height="245px" style={{ display: 'block' }} />
        </Card>

        <Card className="time-intervals">
          <h3>
            <Translation id="Time intervals" />
          </h3>

          <Skeleton height="245px" style={{ display: 'block' }} />
        </Card>

        <Card className="flags">
          <h3>
            <Translation id="Misc" />
          </h3>

          <Skeleton height="245px" style={{ display: 'block' }} />
        </Card>
      </div>

      <Button>
        <Skeleton width={isMobile() ? '220px' : '280px'} height="24px" />
      </Button>

      <Button>
        <Skeleton width="200px" height="24px" />
      </Button>
    </>
  )
}

export default SettingsSkeleton
